import { DefaultButton, PrimaryButton, Stack, TextField, Checkbox, Slider, Dropdown, Spinner, MessageBar, StackItem, Text, Toggle } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { MyContext } from '../../../../context';
import * as QueryAP from '../AdherencePhrasesQuery'
import InputFieldTitle from '../InputFieldTitle'
import RISlider from '../RISlider';

export default class EditAdherencePhrase extends Component {
    static contextType = MyContext

    constructor(props) {
        super(props);
        const phrase = this.props.data !== undefined ? this.props.data : null
        this.state = {
            //page data
            processing: false,
            //phrase data
            id: phrase !== null ? phrase.id : null,
            name: phrase !== null ? phrase.name : "",
            description: phrase !== null ? phrase.description : "",
            phrase: phrase !== null ? phrase.phrase : "",
            tenantId: phrase !== null ? phrase.tenantId : null,
            adherence: phrase !== null ? phrase.adherence : 0,
            version: phrase !== null ? phrase.version : 0,
            masterItemId: phrase !== null ? phrase.masterItemId : null,
            selected: phrase !== null ? phrase.selected : true,
            //versions
            selectedOtherVersion: false,
            selectedVersion: phrase !== null ? phrase.id : null,
            contained: phrase !== null ? phrase.contained : false
        };
    }

   

    componentDidMount() {
        this.refreshVersions()
    }

    refetchQueryVersions = null;
    numberOfVersions = 1

    refreshVersions = () => {
        if (this.refetchQueryVersions !== null) {
            this.refetchQueryVersions()
        }
    }

    changeText = (e, value) => {
        this.setState({
            [e.target.id]: value,
            selectedOtherVersion: false
        })
    }

    isValid = () => {
        return this.state.name !== "" && this.state.phrase !== "" && (this.state.adherence !== "" && !isNaN(parseFloat(this.state.adherence)));
    }

    cancel = () => {
        this.props.closePanel()
    }

    save = () => {
        this.setState({ processing: true })
        const auth = this.props.auth
        const adherencePhrase = {
            id: this.state.id,
            name: this.state.name.trim(),
            description: this.state.description,
            phrase: this.state.phrase,
            adherence: parseFloat(this.state.adherence),
            tenantId: this.state.tenantId,
            // manage version
            version: this.numberOfVersions,
            masterItemId: this.state.masterItemId,
            selected: this.state.selected,
            contained: this.state.contained
        }
        this.props.apol
            .mutate({
                mutation: QueryAP.createAdherencePhrase,
                variables: { auth, adherencePhrase }
            })
            .then((result) => {
                var state = {}
                if (result.data.upsertAdherencePhrase.status === "ok") {
                    this.props.closePanel()
                    this.props.refreshPhrases()
                } else {
                     this.props.setMessageError(this.context.getTranslation("compliance", result.data.upsertAdherencePhrase.text))
        

                }
                this.setState({ ...state, processing: false })
            });
    }



    onContainedToggleChange = (e, checked) => {
        this.setState({
            contained: !this.state.contained,
            selectedOtherVersion: false
        })
    }

    onChangeVersion = (e, item) => {
        //get specific version to fill the fields
        this.setState({ processing: true })
        let id = item.key
        let auth = this.props.auth
        this.props.apol
            .query({
                query: QueryAP.queryGetAdherencePhrase,
                variables: { auth, id }
            })
            .then(({ loading, error, data, refetch }) => {
                let oldVersion = data.getAdherencePhrase;
                let exact = oldVersion.adherence === 100
                this.setState({
                    name: oldVersion.name,
                    description: oldVersion.description,
                    phrase: oldVersion.phrase,
                    exact,
                    adherence: exact ? parseFloat(100) : parseFloat(oldVersion.adherence),
                    tenantId: oldVersion.tenantId,
                    selectedVersion: id,
                    selectedOtherVersion: true,
                    processing: false
                })
            });
    }

    restoreVersion = () => {
        this.setState({ processing: true })
        //restoreAdherencePhrase -> id vesrion to restore
        let id = this.state.selectedVersion
        this.props.apol
            .mutate({
                mutation: QueryAP.restoreAdherencePhrase,
                variables: { id }
            })
            .then((result) => {
                if (result.data.restoreAdherencePhrase.status === "ok") {
                    this.props.closePanel()
                    this.props.refreshPhrases()
                } else {
                    this.props.setMessageError(this.context.getTranslation("compliance", result.data.restoreAdherencePhrase.text))
                }
                this.setState({
                    selectedOtherVersion: false,
                    processing: false
                })
            });
    }

    onAdherenceSliderChange = (newAdhValue) => {
        if (newAdhValue === 0 || newAdhValue === 100) {
            let contained = newAdhValue !== 0 
            this.setState({
                adherence: newAdhValue,
                contained
            })
        } else {
            this.setState({
                adherence: newAdhValue
            })
        }
    }

    render() {
        let masterItemId = this.state.masterItemId
        let diableIncludeExclude = this.state.adherence === 0 || this.state.adherence === 100
        return (
            <div>
                {/*QUERY ALL VERSIONS*/}
                <Query
                    query={QueryAP.getAllVersionOfAdherencePhrase}
                    variables={{ masterItemId }}>
                    {({ loading, error, data, refetch }) => {
                        this.refetchQueryVersions = refetch
                        if (loading) {
                            return (<Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />)
                        }
                        if (error) {
                            return ""
                        }
                        if (data.getAllVersionOfAdherencePhrase == null) {
                            return ""
                        }
                        let versions = data.getAllVersionOfAdherencePhrase.map(v => {
                            return {
                                "key": v.id,
                                "text": v.version
                            }
                        })
                        this.numberOfVersions = versions.length
                        return (<div>
                            {versions.length > 0 && <Stack >
                                <Stack.Item>
                                    <Dropdown
                                        label={this.context.getTranslation("compliance", "version")}
                                        selectedKey={this.state.selectedVersion}
                                        onChange={this.onChangeVersion}
                                        options={versions}
                                    />
                                </Stack.Item>
                            </Stack>}
                        </div>
                        )
                    }}
                </Query>
                <TextField label={this.context.getTranslation("compliance", "name")} id="name" value={this.state.name} onChange={this.changeText} required />
                <TextField label={this.context.getTranslation("compliance", "description")} id="description" value={this.state.description} onChange={this.changeText} />
                <TextField label={this.context.getTranslation("compliance", "phrase")} id="phrase" value={this.state.phrase} onChange={this.changeText} required />
                <Stack>
                    <Stack.Item>
                        <RISlider
                            label={this.context.getTranslation("compliance", "adherenceValue")}
                            showPercentage={true}
                            startLabel={this.context.getTranslation("compliance", "notMentioned")}
                            endLabel={this.context.getTranslation("compliance", "wordByWord")}
                            showValue={true}
                            min={0}
                            max={100}
                            input={this.state.adherence}
                            onSliderChange={value => this.onAdherenceSliderChange(value)}
                            revert={this.state.contained}
                        />
                    </Stack.Item>
                </Stack>
                <Stack >
                    <InputFieldTitle required={true} label={this.context.getTranslation("compliance", "includeExclude")} disabled={diableIncludeExclude } />
                    <Text style={diableIncludeExclude ? { color: "rgb(89, 89, 89)" } : {}}>{this.context.getTranslation("compliance", "includeExcludeDescriptionPhrase")}</Text>
                    <StackItem style={{ marginTop: "5px" }}>
                        <Toggle
                            onText={this.context.getTranslation("compliance", "exceeded")}
                            offText={this.context.getTranslation("compliance", "fallenBelow")}
                            checked={this.state.contained}
                            onChange={this.onContainedToggleChange}
                            disabled={diableIncludeExclude}
                        />
                    </StackItem>
                </Stack>
                {/*FOOTER BUTTONS*/}
                <Stack horizontal style={{ flexFlow: "row-reverse" }}>
                    <DefaultButton text={this.context.getTranslation("common", "cancel")} onClick={this.cancel} style={{ marginTop: "30px", marginLeft: "15px" }} disabled={this.state.processing} />
                    {(!this.state.selectedOtherVersion || this.state.id === this.state.selectedVersion) &&
                        <PrimaryButton text={this.context.getTranslation("common", "save")} onClick={this.save} style={{ marginTop: "30px", marginLeft: "15px" }} disabled={!this.isValid() || this.state.processing} />
                    }
                    {this.state.selectedOtherVersion && this.state.id !== this.state.selectedVersion &&
                        <PrimaryButton text={this.context.getTranslation("compliance", "restoreVersion")} onClick={this.restoreVersion} style={{ marginTop: "30px", marginLeft: "15px" }} disabled={!this.isValid() || this.state.processing} />
                    }
                </Stack>
            </div>
        );
    }
}